import { render, staticRenderFns } from "./QuotedBadge.vue?vue&type=template&id=57fb38b4&scoped=true&"
import script from "./QuotedBadge.vue?vue&type=script&lang=ts&"
export * from "./QuotedBadge.vue?vue&type=script&lang=ts&"
import style0 from "./QuotedBadge.vue?vue&type=style&index=0&id=57fb38b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb38b4",
  null
  
)

export default component.exports